import { Header } from "../../components/Header"
import { useParams } from "react-router-dom";
import { IP } from "../../components/IP"
import { IpData, getIp } from "../../remote/scan_data";
import { useEffect, useState } from "react";
import { ScanChildren } from "../../components/ScanChildren";
import { Box, CircularProgress, Container } from "@mui/material";

export const TreeIp = () => {
	const params = useParams()
	const entityId = params.entityId;

	if ( ! entityId) {
		return <CircularProgress />
	}

	const [ipData, setIpData] = useState<IpData | null>(null);
	useEffect(() => {
		getIp(entityId, (data, resp) => {
			if (data) {
				setIpData(data);
			} else {
				setIpData(null);
			}
		});
	}, [setIpData]);

	return (ipData ? <>
		<Header />
		<Container>
			<IP id={entityId} data={ipData} hideChildren/>
			<Box margin={1}></Box>
			<ScanChildren data={ipData.children} />
		</Container>
	</> : <CircularProgress />)
}
